export default "__VITE_ASSET__CseJpZzV__"